<template>
  <v-container id="clientAboutGuardians" class="pa-0 pb-5">
    <v-form ref="form" v-model="form.valid">
    <v-progress-linear class="ma-0" v-if="isAllLoading" indeterminate color="blue"></v-progress-linear>
      <v-row dense>
        <v-col v-for="(item, idx) in getGuardianItems"
          :key="item.id"
          ref="guardian"
          cols="12"
          :sm="isEmbedded ? '12' : '6'">
          <v-card>
            <v-card-title class="pa-0">
              <ClientAboutGuardiansName :ref="'name' + idx"
                :data="item"
                :index="idx"
                :status="getStatus"
                @emit="emitted"
              />
            </v-card-title>
            <v-divider color="grey"></v-divider>
            <v-card-text>
              <v-list two-line>
                <v-subheader>住まい</v-subheader>
                <ClientAboutGuardiansAddress v-for="jtem in item.addresses"
                  :ref="'address' + idx"
                  :key="jtem.id"
                  :gid="item.id"
                  :data="jtem"
                  :status="getStatus"
                  @emit="emitted"></ClientAboutGuardiansAddress>
                <ClientAboutGuardiansAddressInsert class="abt-item mb-3 blue--text text--darken-2" :gid="item.id" @emit="emitted"></ClientAboutGuardiansAddressInsert>
                <v-subheader>連絡先</v-subheader>
                <ClientAboutGuardiansContact v-for="jtem in item.contacts"
                  :ref="'contact' + idx"
                  :key="jtem.id"
                  :gid="item.id"
                  :data="jtem"
                  :status="getStatus"
                  @emit="emitted"></ClientAboutGuardiansContact>
                <ClientAboutGuardiansContactInsert class="abt-item mb-3 blue--text text--darken-2" :gid="item.id" @emit="emitted"></ClientAboutGuardiansContactInsert>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
        <ClientAboutGuardiansRegister v-if="!isAllLoading && getGuardianItems.length < getLimit" @emit="emitted"></ClientAboutGuardiansRegister>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import ClientAboutGuardiansName from './components/name'
import ClientAboutGuardiansAddress from './components/home'
import ClientAboutGuardiansAddressInsert from './components/home/modals/insert'
import ClientAboutGuardiansContact from './components/contact'
import ClientAboutGuardiansContactInsert from './components/contact/modals/insert'
import ClientAboutGuardiansRegister from './components/register'

const DEFAULT = {
  STATUS: {
    LOADING: 'all',
    EDITING: '',
    SUBMITTING: '',
    INDEX: 0,
    LIMIT: 2
  },
  FORM: {
    ITEM: {
      DEFAULT: JSON.stringify({
        value: '',
        required: false
      }),
      REQUIRED: JSON.stringify({
        value: '',
        required: true
      })
    }
  }
}
export default {
  name: 'clientAboutGuardians',
  components: {
    ClientAboutGuardiansName,
    ClientAboutGuardiansAddress,
    ClientAboutGuardiansAddressInsert,
    ClientAboutGuardiansContact,
    ClientAboutGuardiansContactInsert,
    ClientAboutGuardiansRegister
  },
  props: [ 'embedded', 'test' ],
  data () {
    return {
      config: {
        status: {
          index: DEFAULT.STATUS.INDEX,
          limit: DEFAULT.STATUS.LIMIT,
          loading: DEFAULT.STATUS.LOADING,
          editing: DEFAULT.STATUS.EDITING
        }
      },
      form: {
        valid: true
      },
      store: []
    }
  },
  created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    init: function () {
      this.$nextTick(() => {
        this.get()
      })
    },
    get: function (type) {
      this.$set(this.config.status, 'loading', type != null ? type : 'all')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: true
        }
      })
      this.$firebase.auth().currentUser.getIdToken(true).then(token => {
        this.axios.post(this.$url.api + 'about/get/guardians', {
          cid: this.$route.params.id
        }, {
          headers: {
            'firebase-token': token
          }
        }).then(res => {
          console.log(res)
          this.$set(this.config.status, 'loading', '')
          this.$emit('emit', {
            action: 'state',
            data: {
              type: 'loading',
              status: false
            }
          })
          if (res.data && res.data.success) {
            this.$set(this, 'store', res.data.data)
          }
        })
      })
    },
    prepare: function () {
      for (let i = 0; i < this.$refs.guardian.length; i++) {
        this.$refs['name' + i][0].prepare()
        for (let j = 0; j < this.$refs['address' + i].length; j++) {
          this.$refs['address' + i][j].prepare()
        }
        for (let j = 0; j < this.$refs['contact' + i].length; j++) {
          this.$refs['contact' + i][j].prepare()
        }
      }
      this.edit()
    },
    edit: function (req) {
      const { id, type } = req || {}
      if (this.config.status.editing) {
        this.submit({ type: 'series' })
      }
      if (id) {
        this.$set(this.config.status, 'editing', id)
      } else if (type) {
        this.$set(this.config.status, 'editing', type)
      } else {
        this.$set(this.config.status, 'editing', 'all')
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: true
        }
      })
    },
    preSubmit: function (req) {
      const { type } = req
      const urls = {
        update: `${this.$url.api}about/update/guardians`,
        series: `${this.$url.api}about/update/guardians`
      }
      if (this.$refs.form.validate()) {
        let fd = {
          cid: this.$route.params.id,
          guardians: []
        }
        for (let i = 0; i < this.store.length; i++) {
          let gud = {
            id: this.store[i].id,
            addresses: [],
            contacts: []
          }
          if (['name' + i, 'all'].includes(this.config.status.editing)) {
            Object.assign(gud, this.$refs['name' + i][0].getForm())
          }
          if (this.config.status.editing === 'all') {
            if (this.$refs[`address${i}`] && this.$refs[`address${i}`].length) {
              for (let j = 0; j < this.$refs['address' + i].length; j++) {
                gud.addresses.push(this.$refs['address' + i][j].getForm())
              }
            }
            if (this.$refs[`contact${i}`] && this.$refs[`contact${i}`].length) {
              for (let j = 0; j < this.$refs['contact' + i].length; j++) {
                gud.contacts.push(this.$refs['contact' + i][j].getForm())
              }
            }
          }
          if (this.config.status.editing.indexOf('addr_') >= 0) {
            let idx = this.$refs['address' + i].findIndex(it => {
              return it.isThisEditing
            })
            if (idx >= 0) {
              gud.addresses.push(this.$refs['address' + i][idx].getForm())
            }
          }
          if (this.config.status.editing.indexOf('cont_') >= 0) {
            let idx = this.$refs['contact' + i].findIndex(it => {
              return it.isThisEditing
            })
            if (idx >= 0) {
              gud.contacts.push(this.$refs['contact' + i][idx].getForm())
            }
          }
          fd.guardians.push(gud)
        }
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'loading',
            status: true
          }
        })
        if (type && urls[type]) {
          const url = urls[type]
          return { url, fd, type }
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const type = (req && req.type) ? req.type : 'update'
      const dt = this.preSubmit({ type })
      if (dt) {
        const { url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({ type })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type } = req || {}
      if (type !== 'series') {
        this.$set(this.config.status, 'editing', '')
        this.$emit('emit', {
          action: 'state',
          data: {
            type: 'editing',
            status: false
          }
        })
      }
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.get(this.config.status.editing)
    },
    failSubmit: function () {
      this.$set(this.config.status, 'editing', '')
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'loading',
          status: false
        }
      })
      this.$emit('emit', {
        action: 'state',
        data: {
          type: 'editing',
          status: false
        }
      })
    },
    insert: function (req) {
      this.store.push(req)
    },
    insertAddress: function (req) {
      if (
        req &&
        req.id &&
        req.address
      ) {
        let idx = this.store.findIndex(it => {
          return it.id === req.id
        })
        if (idx >= 0 && this.store[idx].addresses) {
          this.store[idx].addresses.push(req.address)
          this.$nextTick(() => {
            this.$refs['address' + idx][this.$refs['address' + idx].length - 1].prepare()
          })
        }
      }
    },
    insertContact: function (req) {
      if (
        req &&
        req.id &&
        req.contact
      ) {
        let idx = this.store.findIndex(it => {
          return it.id === req.id
        })
        if (idx >= 0 && this.store[idx].contacts) {
          this.store[idx].contacts.push(req.contact)
          this.$nextTick(() => {
            this.$refs['contact' + idx][this.$refs['contact' + idx].length - 1].prepare()
          })
        }
      }
    },
    removeAddress: function (req) {
      if (req) {
        let idx = (this.store.length > 0 && this.store[0].addresses) ? this.store[0].addresses.findIndex(it => {
          return it.id === req
        }) : -1
        if (idx >= 0) {
          this.store[0].addresses.splice(idx, 1)
        }
        let jdx = (this.store.length > 1 && this.store[1].addresses) ? this.store[1].addresses.findIndex(it => {
          return it.id === req
        }) : -1
        if (jdx >= 0) {
          this.store[1].addresses.splice(jdx, 1)
        }
      }
    },
    removeContact: function (req) {
      if (req) {
        let idx = (this.store.length > 0 && this.store[0].contacts) ? this.store[0].contacts.findIndex(it => {
          return it.id === req
        }) : -1
        if (idx >= 0) {
          this.store[0].contacts.splice(idx, 1)
        }
        let jdx = (this.store.length > 1 && this.store[1].contacts) ? this.store[1].contacts.findIndex(it => {
          return it.id === req
        }) : -1
        if (jdx >= 0) {
          this.store[1].contacts.splice(jdx, 1)
        }
      }
    },
    close: function () {
      this.$set(this.config.status, 'editing', '')
    },
    getStore: function () {
      return this.store
    },
    emitted: function (req) {
      if (req && req.action) {
        this[req.action](req.data)
      }
    }
  },
  computed: {
    isEmbedded () {
      return this.$props.embedded != null && this.$props.embedded !== false
    },
    isValid () {
      return this.form.valid
    },
    isEditing () {
      return this.config.status.editing
    },
    isAllEditing () {
      return this.config.status.editing === 'all'
    },
    isLoading () {
      return !!this.config.status.loading
    },
    isAllLoading () {
      return this.config.status.loading === 'all'
    },
    getGuardianItems () {
      return (this.store && this.store.length) ? this.store : []
    },
    getLimit () {
      return this.config.status.limit
    },
    getStatus () {
      return this.config.status
    }
  }
}
</script>
